import {
  apiClient,
  handleResponse,
} from './axios';

async function getEvaluoExamsByCompanyAndSemester(companyId, semester) {
  try {
    const response = await apiClient.get(`/evaluo/get-exams/${companyId}/${semester}`);
    const exams = await handleResponse(response);
    return exams;
  } catch (error) {
    const res = await Promise.reject(error.response.data);
    return res;
  }
}
async function getEvaluoExamsByCompanyAndStudent(companyId, semester, evaluoId) {
  try {
    const response = await apiClient.get(`/evaluo/get-exams/student/${companyId}/${semester}/${evaluoId}`);
    const exams = await handleResponse(response);
    return exams;
  } catch (error) {
    const res = await Promise.reject(error.response.data);
    return res;
  }
}
async function getEvaluoUserToken(userId, url) {
  try {
    const response = await apiClient.post('/evaluo/token/user-token', { userId, url });
    const userToken = await handleResponse(response);
    return userToken;
  } catch (error) {
    const res = await Promise.reject(error.response.data);
    return res;
  }
}

const evaluoExamServices = {
  getEvaluoExamsByCompanyAndSemester,
  getEvaluoExamsByCompanyAndStudent,
  getEvaluoUserToken,
};

export default evaluoExamServices;
